import React from 'react';

type BcallLogoProps = {
  size?: number;
};

export const BcallLogo: React.FC<BcallLogoProps> = ({ size = 40 }) => {
  return (
    <svg
      aria-label="Bcall"
      role="img"
      width={size}
      height={size}
      viewBox="0 0 223 196"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        stroke="#8bc34a"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth="16.52"
        d="M148.29 106.01c0-20.03-17.39-36.52-38.51-36.52-18.49 0-34.11 12.62-37.73 29.2-.95 4.34-4.98 7.32-9.42 7.32H50.95c-5.82 0-10.4-5.21-9.39-10.95 5.58-31.8 35.02-56.36 70.03-56.36s66.23 26.08 70.47 59.27c.59 4.64 4.69 8.03 9.37 8.03h13.19c5.69 0 10.1-4.98 9.44-10.63-5.66-48.7-49.7-87.12-102.47-87.12C55.04 8.26 8.5 52.38 8.5 106.01"
      />
      <path
        fill="#8bc34a"
        d="M120.76 165.99c-6.28.74-12.62.74-18.91 0-14.49-1.71-40.64-6.59-41.71-19.67-1.49-18.13-16.34-17.05-16.34-17.05s-25.96.03-34.27 0c-5.67-.02-8.47 4.97-8.47 4.97-9.8 15.82 49.93 61.15 110.25 61.15s120.05-45.34 110.25-61.15c0 0-2.81-4.99-8.47-4.97-8.31.03-34.27 0-34.27 0s-14.85-1.08-16.34 17.05c-1.08 13.08-27.22 17.96-41.71 19.67Z"
      />
    </svg>
  );
};
